import script from "./svgIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./svgIcon.vue?vue&type=script&setup=true&lang=js"

import "./svgIcon.vue?vue&type=style&index=0&id=8f1d1486&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.2.13_webpack@5.101.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f1d1486"]])

export default __exports__